import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";

const initial = {
    platform: "",
    clientName: "",
    postalType: "",
    marginPrice: 0,
    insPrice: 0,
};

const CreateDialog = ({ visible, onHide, onSubmit, loading, orgs = [] }) => {
    const [data, setData] = React.useState(initial);
    const [submitted, setSubmitted] = React.useState(false);

    React.useEffect(() => {
        if (visible) {
            setData(initial);
            setSubmitted(false);
        }
    }, [visible]);

    const update = (k, v) => setData(d => ({ ...d, [k]: v }));

    const isValid =
        !!data.platform &&
        data.clientName.trim() &&
        !!data.postalType.trim() &&
        data.marginPrice >= 0 &&
        data.insPrice >= 0;

    const handleSave = () => {
        setSubmitted(true);
        if (!isValid) return;
        onSubmit(data);
    };

    const footer = (
        <div>
            <Button label="Отмена" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Сохранить" icon="pi pi-check" loading={loading} onClick={handleSave} />
        </div>
    );

    return (
        <Dialog header="Создать тариф SLQ" visible={visible} style={{ width: "500px" }}
                modal onHide={onHide} footer={footer}>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12">
                    <label>Платформа *</label>
                    <Dropdown value={data.platform} options={orgs}
                              optionLabel="name" optionValue="name"
                              onChange={e => update("platform", e.value)}
                              placeholder="Выберите"
                              className={submitted && !data.platform ? "p-invalid" : ""} />
                </div>
                <div className="p-field p-col-12">
                    <label>Клиент *</label>
                    <InputText value={data.clientName} onChange={e => update("clientName", e.target.value)}
                               className={submitted && !data.clientName.trim() ? "p-invalid" : ""} />
                </div>
                <div className="p-field p-col-12">
                    <label>Тип отправления *</label>
                    <InputText value={data.postalType} onChange={e => update("postalType", e.target.value)}
                               className={submitted && !data.postalType.trim() ? "p-invalid" : ""} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Маржа</label>
                    <InputNumber value={data.marginPrice} mode="decimal" minFractionDigits={2} min={0}
                                 onValueChange={e => update("marginPrice", e.value ?? 0)} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <label>Страховка</label>
                    <InputNumber value={data.insPrice} mode="decimal" minFractionDigits={2} min={0}
                                 onValueChange={e => update("insPrice", e.value ?? 0)} />
                </div>
            </div>
        </Dialog>
    );
};

export default CreateDialog;
